import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import WillsFormWidget from 'helpers/WillsForm/FormWidget';
const WillsForm = (props)=>{
    const { fields, params } = props;
    const { base } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("div", {
        className: base(),
        children: /*#__PURE__*/ _jsx(WillsFormWidget, {
            formfields: fields,
            params: params
        })
    });
};
export default WillsForm;
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'w-full',
            'flex',
            'flex-col',
            'py-component-section-container-padding-y'
        ]
    }
});
